import React, { useState } from "react";
import axios from "axios";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { base_url } from "../../context/Authcontext";
import toast from "react-hot-toast";
import "../../assets/AdminCss/forgot.css"; // Import the CSS file

export default function ForgotPassword({
  forgotPasswordActive,
  setForgotPasswordActive,
}) {
  const [forgotPasswordData, setForgotPasswordData] = useState({
    phoneNumber: '',
    oldPassword: '',
    newPassword: '',
    confirmNewPassword: ''
  });

  const [isPassVisible, setPassVisible] = useState({
    oldPassword: false,
    newPassword: false,
    confirmNewPassword: false
  });

  const submitForgotPassword = async (e) => {
    e.preventDefault();

    // Existing validation logic remains the same
    if (!forgotPasswordData.phoneNumber) {
      toast.error('Please enter your mobile number');
      return;
    }

    if (forgotPasswordData.phoneNumber.length !== 10) {
      toast.error('Mobile number must be 10 digits');
      return;
    }

    if (!forgotPasswordData.oldPassword) {
      toast.error('Please enter your old password');
      return;
    }

    if (!forgotPasswordData.newPassword) {
      toast.error('Please enter a new password');
      return;
    }

    if (forgotPasswordData.newPassword !== forgotPasswordData.confirmNewPassword) {
      toast.error('New passwords do not match');
      return;
    }

    try {
      const response = await axios.post(`${base_url}/api/webapi/change/passUser`, {
        phoneNumber: forgotPasswordData.phoneNumber,
        oldPassword: forgotPasswordData.oldPassword,
        newPassword: forgotPasswordData.newPassword
      });

      if (response.data.message) {
        toast.success('Password changed successfully');
        setForgotPasswordActive(false);
      } else {
        toast.error(response.data.message || 'Password change failed');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'An error occurred');
      console.error("Password change error:", err);
    }
  };

  const togglePasswordVisibility = (field) => {
    setPassVisible(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  return (
    <div 
      className={`forgot-password-modal ${forgotPasswordActive ? '' : 'hidden'}`}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          setForgotPasswordActive(false);
        }
      }}
    >
      <div 
        className="forgot-password-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="forgot-password-header">
          <h2 className="forgot-password-title">Reset Password</h2>
          <button 
            className="close-button"
            onClick={() => setForgotPasswordActive(false)}
          >
            &times;
          </button>
        </div>

        <form 
          className="forgot-password-form" 
          onSubmit={submitForgotPassword}
        >
          <div className="form-group">
            <input
              type="text"
              placeholder="Mobile No"
              className="form-input"
              value={forgotPasswordData.phoneNumber}
              onChange={(e) =>
                setForgotPasswordData({
                  ...forgotPasswordData,
                  phoneNumber: e.target.value.replace(/[^0-9]/, ""),
                })
              }
              maxLength={10}
            />
          </div>

          <div className="form-group">
            <input
              type={isPassVisible.oldPassword ? "text" : "password"}
              placeholder="Old Password"
              className="form-input"
              value={forgotPasswordData.oldPassword}
              onChange={(e) =>
                setForgotPasswordData({
                  ...forgotPasswordData,
                  oldPassword: e.target.value,
                })
              }
            />
            <button
              type="button"
              className="password-toggle"
              onClick={() => togglePasswordVisibility('oldPassword')}
            >
              {isPassVisible.oldPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <div className="form-group">
            <input
              type={isPassVisible.newPassword ? "text" : "password"}
              placeholder="New Password"
              className="form-input"
              value={forgotPasswordData.newPassword}
              onChange={(e) =>
                setForgotPasswordData({
                  ...forgotPasswordData,
                  newPassword: e.target.value,
                })
              }
            />
            <button
              type="button"
              className="password-toggle"
              onClick={() => togglePasswordVisibility('newPassword')}
            >
              {isPassVisible.newPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <div className="form-group">
            <input
              type={isPassVisible.confirmNewPassword ? "text" : "password"}
              placeholder="Confirm New Password"
              className="form-input"
              value={forgotPasswordData.confirmNewPassword}
              onChange={(e) =>
                setForgotPasswordData({
                  ...forgotPasswordData,
                  confirmNewPassword: e.target.value,
                })
              }
            />
            <button
              type="button"
              className="password-toggle"
              onClick={() => togglePasswordVisibility('confirmNewPassword')}
            >
              {isPassVisible.confirmNewPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <button
            type="submit"
            className="submit-button"
          >
            Reset Password
          </button>
        </form>
      </div>
    </div>
  );
}